export default __webpack_public_path__ + "static/media/to.a82e8e72.jpg";